// extracted by mini-css-extract-plugin
module.exports = {"share":"share_share__3DRJq","facebook":"share_facebook__6qbpc","twitter":"share_twitter__1kjhe","line":"share_line__1ejmr"};